import React, {useState} from 'react';
import {checkIsSImmsADmin, requestLicenseKey, requestSecondVersionLicenseKey} from "../../api/user/UserAccountService";

function SimmsLicense(props) {

    const [simmsId, setSimmsId] =useState();
    const [simmsPw, setSimmsPw] =useState();
    const [ispass,setIsPass] =useState(false);

    const [third, setThird] = useState({});
    const [secondary, setSecondary] = useState({});
    const [licenseKey, setLicenseKey] =useState();

    const thirdVersionKey = ["expire", "assetCount", "platform"];
    const secondVersionKey = ["prevLicenseKey", "prevLicenseStart", "prevLicenseEnd", "prevLicenseAssetCount"];

    const onPwDown =(event)=>{
        if (event.keyCode === 13) {
            checkIsSImmsADmin(simmsId,simmsPw).then(r=>{
                if(r.status===200){
                    setIsPass(true);

                }
            });
        }
    }

    function requestKey(version){
        if(version === 3) {
            if(thirdVersionKey.some(e=>!third[e])) {
                alert("3.0 필수값 누락");
                return
            }

            requestLicenseKey(third.expire, third.assetCount, third.userCount, third.platform).then(r => {
                if (r.status === 200) {
                    setLicenseKey(r.data);
                    // setIsPass(false);
                }
            });
        }else{
            if(secondVersionKey.some(e=>!secondary[e])) {
                alert("2.5 필수값 누락");
                return
            }

            requestSecondVersionLicenseKey(
                secondary.prevLicenseKey,
                secondary.prevLicenseStart,
                secondary.prevLicenseEnd,
                secondary.prevLicenseAssetCount,
                secondary.prevLicenseUserCount ?? "0"
            ).then(r => {
                if (r.status === 200) {
                    setLicenseKey(r.data);
                    // setIsPass(false);
                }
            });
        }
    }

    return (
        <div>

            {!ispass ?
                < div className={`m-auto w-[400px] mt-[200px]`}>
                    <p className={`m-auto h-[30px] text-center w-[200px] block`}>입력</p>
                    <input type="text" className={`border m-auto h-[30px] w-[200px] block mb-[20px]`}
                        placeholder={''}
                        value={simmsId}
                        onChange={(e)=>setSimmsId(e.target.value)}
                    />
                    <input type="text" className={`border m-auto h-[30px] w-[200px] block`}
                           placeholder={''}
                           value={simmsPw}
                           onChange={(e)=>setSimmsPw(e.target.value)}
                           onKeyDown={onPwDown}
                    />
                </div>
                :
                <div className="m-auto w-[900px] mt-[100px] flex justify-center gap-10">
                    {/* 3.0 라이선스 */}
                    <div className="flex flex-col justify-between w-[250px] border p-4 rounded-md">
                        <div>
                            <p className="text-center mb-5 font-semibold">3.0 라이선스</p>

                            <label className="block text-center">종료일</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={third?.expire || ""}
                                onChange={(e) => setThird((prev) => ({ ...prev, expire: e.target.value }))}
                            />

                            <label className="block text-center">자산수</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={third?.assetCount || ""}
                                onChange={(e) => setThird((prev) => ({ ...prev, assetCount: e.target.value }))}
                            />

                            <label className="block text-center">사용자수</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={third?.userCount || ""}
                                onChange={(e) => setThird((prev) => ({ ...prev, userCount: e.target.value }))}
                            />

                            <label className="block text-center">서비스유형</label>
                            <input
                                className="border w-full h-[30px]"
                                value={third?.platform || ""}
                                onChange={(e) => setThird((prev) => ({ ...prev, platform: e.target.value }))}
                            />
                        </div>

                        <button
                            className="w-full mt-[20px] h-[35px] bg-amber-600 text-white rounded"
                            onClick={() => requestKey(3)}
                        >
                            3.0 생성하기
                        </button>
                    </div>

                    {/* 2.5 라이선스 */}
                    <div className="flex flex-col justify-between w-[250px] border p-4 rounded-md">
                        <div>
                            <p className="text-center mb-5 font-semibold">2.5 라이선스</p>

                            <label className="block text-center">라이선스키</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={secondary?.prevLicenseKey || ""}
                                onChange={(e) => setSecondary((prev) => ({ ...prev, prevLicenseKey: e.target.value }))}
                            />

                            <label className="block text-center">시작일</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={secondary?.prevLicenseStart || ""}
                                onChange={(e) => setSecondary((prev) => ({ ...prev, prevLicenseStart: e.target.value }))}
                            />

                            <label className="block text-center">종료일</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={secondary?.prevLicenseEnd || ""}
                                onChange={(e) => setSecondary((prev) => ({ ...prev, prevLicenseEnd: e.target.value }))}
                            />

                            <label className="block text-center">자산수</label>
                            <input
                                className="border w-full h-[30px] mb-[15px]"
                                value={secondary?.prevLicenseAssetCount || ""}
                                onChange={(e) => setSecondary((prev) => ({ ...prev, prevLicenseAssetCount: e.target.value }))}
                            />

                            <label className="block text-center">사용자수</label>
                            <input
                                className="border w-full h-[30px]"
                                value={secondary?.prevLicenseUserCount || ""}
                                onChange={(e) => setSecondary((prev) => ({ ...prev, prevLicenseUserCount: e.target.value }))}
                            />
                        </div>

                        <button
                            className="w-full mt-[20px] h-[35px] bg-amber-600 text-white rounded"
                            onClick={() => requestKey(2.5)}
                        >
                            2.5 생성하기
                        </button>
                    </div>
                </div>
            }

            <p className={`block w-[700px] text-center m-auto mt-[20px] text-[17px]`}>
                {typeof licenseKey === 'string' ? (
                    <p className="block w-[700px] text-center m-auto mt-[20px] text-[17px]">
                        {licenseKey}
                    </p>
                ) : (
                    <div className="w-[700px] m-auto mt-[20px] p-3">
                        {licenseKey && Object.entries(licenseKey).map(([key, value]) => (
                            <div key={key} className="flex justify-between text-[15px] py-1">
                                <span>{String(value)}</span>
                            </div>
                        ))}
                    </div>
                )}
            </p>
        </div>
    );
}

export default SimmsLicense;